var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._g({ staticClass: "ui-dropdown", class: _vm.classes }, _vm.$listeners),
    [
      _c(
        "div",
        _vm._g(
          {
            ref: "trigger",
            staticClass: "ui-dropdown__trigger",
            class: _vm.triggerClass,
          },
          _vm.trigger_listeners
        ),
        [_vm._t("default", null, null, { shown: _vm.local_shown })],
        2
      ),
      _c(
        _vm.mountSelf ? _vm.fade_transition : "mounting-portal",
        {
          tag: "component",
          attrs: {
            transition: _vm.fade_transition,
            "mount-to": _vm.mountTo,
            append: "",
          },
        },
        [
          _vm.local_shown && !_vm.disabled
            ? _c(
                "div",
                _vm._g(
                  {
                    ref: "portal",
                    staticClass: "ui-dropdown-portal",
                    class: _vm.portal_classes,
                    style: _vm.portal_styles,
                  },
                  _vm.portal_listeners
                ),
                [
                  _c(
                    "div",
                    { staticClass: "ui-dropdown-portal__layout" },
                    [
                      _vm._t("portal", null, null, { hide: _vm.hide }),
                      _vm.arrow
                        ? _c("div", {
                            staticClass: "ui-dropdown-portal__arrow",
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }